"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.documents = exports.sloth = exports.pig = exports.movie = exports.magnifier = exports.lightbulb = exports.kite = exports.guard = exports.girl = exports.ghost = exports.flower = exports.barChart = exports.bell = exports.calendar2 = exports.calendar = exports.cactus = exports.box = void 0;
var box_1 = require("./box");
Object.defineProperty(exports, "box", { enumerable: true, get: function () { return __importDefault(box_1).default; } });
var cactus_1 = require("./cactus");
Object.defineProperty(exports, "cactus", { enumerable: true, get: function () { return __importDefault(cactus_1).default; } });
var calendar_1 = require("./calendar");
Object.defineProperty(exports, "calendar", { enumerable: true, get: function () { return __importDefault(calendar_1).default; } });
var calendar2_1 = require("./calendar2");
Object.defineProperty(exports, "calendar2", { enumerable: true, get: function () { return __importDefault(calendar2_1).default; } });
var bell_1 = require("./bell");
Object.defineProperty(exports, "bell", { enumerable: true, get: function () { return __importDefault(bell_1).default; } });
var bar_chart_1 = require("./bar-chart");
Object.defineProperty(exports, "barChart", { enumerable: true, get: function () { return __importDefault(bar_chart_1).default; } });
var flower_1 = require("./flower");
Object.defineProperty(exports, "flower", { enumerable: true, get: function () { return __importDefault(flower_1).default; } });
var ghost_1 = require("./ghost");
Object.defineProperty(exports, "ghost", { enumerable: true, get: function () { return __importDefault(ghost_1).default; } });
var girl_1 = require("./girl");
Object.defineProperty(exports, "girl", { enumerable: true, get: function () { return __importDefault(girl_1).default; } });
var guard_1 = require("./guard");
Object.defineProperty(exports, "guard", { enumerable: true, get: function () { return __importDefault(guard_1).default; } });
var kite_1 = require("./kite");
Object.defineProperty(exports, "kite", { enumerable: true, get: function () { return __importDefault(kite_1).default; } });
var lightbulb_1 = require("./lightbulb");
Object.defineProperty(exports, "lightbulb", { enumerable: true, get: function () { return __importDefault(lightbulb_1).default; } });
var magnifier_1 = require("./magnifier");
Object.defineProperty(exports, "magnifier", { enumerable: true, get: function () { return __importDefault(magnifier_1).default; } });
var movie_1 = require("./movie");
Object.defineProperty(exports, "movie", { enumerable: true, get: function () { return __importDefault(movie_1).default; } });
var pig_1 = require("./pig");
Object.defineProperty(exports, "pig", { enumerable: true, get: function () { return __importDefault(pig_1).default; } });
var sloth_1 = require("./sloth");
Object.defineProperty(exports, "sloth", { enumerable: true, get: function () { return __importDefault(sloth_1).default; } });
var documents_1 = require("./documents");
Object.defineProperty(exports, "documents", { enumerable: true, get: function () { return __importDefault(documents_1).default; } });
//# sourceMappingURL=index.js.map